module.exports = __webpack_public_path__ + "img/Strip Lights.44053d47.png";